define('SageDotCom/Components/Navigation/CountrySelector',["jquery"], function($) {
    function CountrySelector(scope) {
        var $modal = $('.modal', scope);
        var $btn = $('.btn', scope);
        var $closeBtn = $('.close', scope);
        var $body = $("body");

        var focusableElements = Array.from(scope.querySelector(".modal").querySelectorAll(
            '.close, a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
        ));

        var firstElement;
        var lastElement;

        if (focusableElements != null && focusableElements.length > 0) {
            firstElement = focusableElements[0];
            lastElement = focusableElements[focusableElements.length - 1];
        }

        var prevFocusableElement;

        // Show the modal
        $btn.on("keypress click", function(event) {
            // This will only work with a click or if the Enter key is pressed
            if (event.keyCode === 13 || event.type === "click") {
                event.preventDefault();
                $body.addClass("modal-open");
                $modal.show();

                prevFocusableElement = document.activeElement;
                trapFocus();
            }
        });

        // Close the modal
        $closeBtn.on("keydown click", function (event) {
            // This will only work with a click or if the Escape key is pressed
            if (event.keyCode === 27 || event.type === "click") {
                event.preventDefault();
                $body.removeClass("modal-open");
                $modal.hide();

                trapFocus();

            }
        });

        function trapFocus() {

            const handleFocus = e => {
                e.preventDefault();
                if (focusableElements.includes(e.target)) {
                    currentFocus = e.target;
                } else {
                    if (currentFocus === firstElement) {
                        lastElement.focus();
                    } else {
                        firstElement.focus();
                    }
                    currentFocus = document.activeElement;
                }
            };

            let currentFocus = null;

            if (document.body.classList.contains("modal-open")) {
                firstElement.focus();
                currentFocus = firstElement;
                document.addEventListener("focus", handleFocus, true);
            }
            else {
                document.removeEventListener("focus", handleFocus, true);
                prevFocusableElement.focus();
            }
        }
    }

    CountrySelector.init = function init(args) {
        return args.IsExperienceEditorEditing === true
            ? null
            : new CountrySelector(args.scope);
    };

    return CountrySelector;
});

